<script setup lang="ts">
import { onMounted, nextTick } from 'vue';
import { type Filters } from '../types/general';
import { multipleSelect } from 'multiple-select-vanilla';

const props = defineProps<{
  filters: Filters;
}>();

const selectedFilters = defineModel<{
  location: string[];
  theme: string[];
  project_type: string[];
}>({
  default: {
    location: [],
    theme: [],
    project_type: [],
  },
});

const isFiltersSelected = () => {
  return selectedFilters.value.location.length > 0 || selectedFilters.value.theme.length > 0 || selectedFilters.value.project_type.length > 0;
}

const clearAll = () => {
  const selects = document.querySelectorAll('select.custom-select[multiple]');
  selects.forEach((select: any) => {
    const selected = select.nextElementSibling.querySelectorAll('.ms-drop li.selected');
    if (selected) {
      selected.forEach((element: any) => {
        const checkbox = element.querySelector('input');
        checkbox.checked = false;
        const clickEvent = new Event('click');
        checkbox.dispatchEvent(clickEvent);
      });
    }
  });
}

onMounted(() => {
  const updatePlaceholder = (select: any) => {
    const placeholder = select.getAttribute('data-placeholder');
    const selectedOptions = select.selectedOptions;
    const selectedCount = selectedOptions.length;

    const placeholderSpan = select.nextElementSibling.querySelector('.ms-choice span');
    if (selectedCount > 0) {
      placeholderSpan.innerHTML = `${placeholder} <span class="count">${selectedCount}</span>`;
    } else {
      placeholderSpan.textContent = placeholder;
    }
  };

  const selects = document.querySelectorAll('select.custom-select[multiple]');
  selects.forEach((select) => {
    multipleSelect(select, {
      selectAll: false,
      width: '100%',
      filter: true,
      displayTitle: true,
      renderOptionLabelAsHtml: true,
      onAfterCreate: () => updatePlaceholder(select),
      onCheckAll: () => updatePlaceholder(select),
      onUncheckAll: () => updatePlaceholder(select),
      onOptgroupClick: () => updatePlaceholder(select),
      onClick: () => updatePlaceholder(select),
    });
  });
});
</script>

<template>
  <div class="search-app-filters">
    <div>
      <select
        class="custom-select"
        name="location"
        id="location"
        v-model="selectedFilters.location"
        data-placeholder="Location"
        multiple
      >
        <option
          v-for="item in Object.values(props.filters.location)"
          :key="item.id"
          :value="item.id"
        >
          {{ item.label }}
        </option>
      </select>
    </div>
    <div>
      <select
        class="custom-select"
        name="theme"
        id="theme"
        v-model="selectedFilters.theme"
        data-placeholder="Theme"
        multiple
      >
        <option
          v-for="item in Object.values(props.filters.theme)"
          :key="item.id"
          :value="item.id"
        >
          {{ item.label }}
        </option>
      </select>
    </div>
    <div>
      <select
        class="custom-select"
        name="project_type"
        id="project_type"
        v-model="selectedFilters.project_type"
        data-placeholder="Project Type"
        multiple
      >
        <option
          v-for="item in Object.values(props.filters.project_type)"
          :key="item.id"
          :value="item.id"
        >
          {{ item.label }}
        </option>
      </select>
    </div>
    <button
      class="clear-all-button"
      v-show="isFiltersSelected()"
      @click="clearAll"
    >
      <span class="material-icons-outlined">restart_alt</span> <span class="text">Clear All</span>
    </button>
  </div>
</template>

<style></style>
